import * as React from 'react';
import style from './ProductionInfo.module.scss';
export interface ProductionInfoProps {}

export default function ProductionInfo(props: ProductionInfoProps) {
  return (
    <div className={style.root}>
      <div className={style.label_container}>Production Info</div>
    </div>
  );
}
